import Repository from './Repository'

const resource = 'locations'

export default {
  getLocations (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, { params: params })
  }
}
